module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image2-983a9088cf1b711a103f7deca2477ae6.png";